export const PACKS = [
  {
    id: "studio",
    no: "01",
    name: "Studio",
    label: { en: "Studio Pack", fr: "Pack Studio" },
    size: "20 – 30 m²",
    image: "/img/studio-v2.jpeg",
    full: true,
    ratio: "1031 / 1024",
    maxW: "max-w-[720px]",
    tagline: {
      en: "One room that sleeps, cooks, works and hosts — without feeling crowded.",
      fr: "Une seule pièce pour dormir, cuisiner, travailler et recevoir — sans jamais se sentir à l'étroit.",
    },
    items: {
      en: ["Upholstered storage bed", "Bistro table & two chairs", "Oak-tone TV & storage unit", "Bedside table & lamp", "Bathroom storage column", "Curtain room divider"],
      fr: ["Lit coffre capitonné", "Table bistrot et deux chaises", "Meuble TV et rangement ton chêne", "Table de chevet et lampe", "Colonne de rangement salle de bain", "Séparation rideau"],
    },
    price: { en: "€999", fr: "999 €" },
    amount: 999,
    shop: "https://z0ajra-0x.myshopify.com/products/basic-pack",
  },
  {
    id: "standard",
    no: "02",
    name: "T1",
    label: { en: "Standard Pack", fr: "Pack Standard" },
    size: "35 – 40 m²",
    image: "/img/t1-v2.jpeg",
    full: true,
    ratio: "896 / 1200",
    maxW: "max-w-[600px]",
    tagline: {
      en: "A bedroom that rests and a living space that gathers — balanced across two zones.",
      fr: "Une chambre pour se reposer et un séjour pour se retrouver — deux espaces en parfait équilibre.",
    },
    items: {
      en: ["Storage bed with ambient light", "Fold-out sofa bed", "Oak TV unit & nightstand", "Dining table & chairs", "Tall oak wardrobe", "Bathroom storage column"],
      fr: ["Lit coffre avec éclairage d'ambiance", "Canapé convertible", "Meuble TV et chevet en chêne", "Table et chaises", "Grande armoire en chêne", "Colonne de rangement salle de bain"],
    },
    price: { en: "€1,599", fr: "1 599 €" },
    amount: 1599,
    shop: "https://z0ajra-0x.myshopify.com/products/standard-pack",
  },
];
